import Box from "@mui/material/Box";
import { PageFrame } from "../../components/page_frame";
import { RunHistoryContainer } from "./container";

export const RunHistoryPage = () => {
  return (
    <PageFrame>
      <Box
        sx={{
          height: "100%",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          flexWrap: "wrap",
          width: "100%",
          maxWidth: "100%",
        }}
      >
        <RunHistoryContainer />
      </Box>
    </PageFrame>
  );
};
